import Footer from "@/components/@extended/Footer";
import MainBox from "@/components/Box/MainBox";
import AlertDialog from "@/components/Dialog/AlertDialog";
import BasicSelect from "@/components/Select/BasicSelect";
import { IBasicSelectItem } from "@/interfaces/Props/Select/IBasicSelectProps";
import { useRecoverProjectUserMutation, useUnRegisterProjectUserMutation } from "@/redux/features/Service/serviceApi";
import { handleNextActiveStep, selectProject } from "@/redux/features/Service/serviceSlice";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import useMessage from "@/useHooks/useMessage";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Layout = () => {

  const dispatch = useAppDispatch();

  const { formatMessage, message } = useMessage();

  const [selectRequirement, setSelectRequirement] = useState<string>("default");

  const [disabledNext, setDisabledNext] = useState<boolean>(false);

  const [dialogMessage, setDialogMessage] = useState<string | JSX.Element>("");

  const [loading, setLoading] = useState(false);

  const service = useAppSelector(selectProject);

  const navigate = useNavigate();

  const [showDialog, setShowDialog] = useState(false);

  const [
    unRegister,
    {
      isSuccess: isUnRegisterSuccess,
      isError: isUnRegisterError,
      error: loginUnRegisterError,
    },
  ] = useUnRegisterProjectUserMutation();
  const [
    recoverUser,
    {
      isSuccess: isRecoverUserSuccess,
      isError: isRecoverUserError,
      error: loginRecoverUserError,
    },
  ] = useRecoverProjectUserMutation();

  const projects: Array<IBasicSelectItem> = [
    { label: "請選擇", value: "default" },
    { label: "註銷帳號", value: "unRegister" },
    { label: "復原帳號", value: "recover" },
  ];

  const handleSelectRequirementCallBack = (value?: string) => {
    if (value) {
      setSelectRequirement(value);
    }
  };

  const handleOnNextClick = () => {
    if (selectRequirement !== "default") {

      switch (selectRequirement) {
        case "unRegister":
          unRegister({ project: service.project });
          break;
        case "recover":
          recoverUser({ project: service.project });
          break;
        default:
          break;
      }
      setLoading(true);
    }
  };

  const handleCloseDialog = () => {

    setShowDialog(false);
    navigate(0);
  };

  useEffect(() => {
    if (selectRequirement === "default") {
      setDisabledNext(true);
    } else {
      setDisabledNext(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectRequirement]);

  useEffect(() => {
    if (isUnRegisterSuccess) {

      setLoading(false);
      dispatch(handleNextActiveStep());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUnRegisterSuccess]);


  useEffect(() => {
    if (isUnRegisterError && loginUnRegisterError) {
      setLoading(false);
      setDialogMessage(message(loginUnRegisterError));
      setShowDialog(true);

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUnRegisterError, loginUnRegisterError]);

  useEffect(() => {
    if (isRecoverUserSuccess) {

      setLoading(false);
      dispatch(handleNextActiveStep());

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRecoverUserSuccess]);

  useEffect(() => {
    if (isRecoverUserError && loginRecoverUserError) {
      setLoading(false);
      setDialogMessage(message(loginUnRegisterError));
      setShowDialog(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRecoverUserError, loginRecoverUserError]);


  return (
    <MainBox height={"100%"} isLoading={loading} >
      <Box sx={{ minHeight: "calc(100% - 50px)" }}>
        <BasicSelect
          label={formatMessage({
            id: "page_three_requirements",
          })}
          defaultValue={selectRequirement}
          items={projects}
          callback={handleSelectRequirementCallBack}
        />
      </Box>
      <Footer
        hideBack
        disabledNext={disabledNext}
        onNextClick={handleOnNextClick}
      />
      <AlertDialog
        type={"info"}
        title={"dialog_info_title"}
        contentText={dialogMessage}
        open={showDialog}
        onCancel={handleCloseDialog}
      />
    </MainBox>
  );
};

export default Layout;
